   import React from 'react';
   import { useTranslation } from 'react-i18next';
   import './AssignButton.scss';
   import assignImage from '../images/assign.svg';

   function AssignButton({ onAssignStoryClick }) {
     const { t } = useTranslation("tutor_assignment_modal");
     return (
       <button className='tutor-assignment-assign-button' onClick={onAssignStoryClick}>
        <img src={assignImage} alt="assign" className='tutor-assignment-assign-button-image'/>
         {t("assign")}
       </button>
     );
   }

   export default AssignButton;